import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { ParticipationRateEntity } from "domain/entity/ParticipationRate/ParticipationRateEntity";
import { ParticipationRateSearchCriteria } from "domain/entity/ParticipationRate/ParticipationRateSearchCriteria";
import { axiosPostData, axiosPutData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { ParticipationRateRepository } from "./ParticipationRateRepo";

/**
 * For template
 * @returns 
 */
export const ParticipationRateRepoImpl = (): ParticipationRateRepository => {
    const url = '/v1/participationRate';

    const getEntities = async (searchCriteria: ParticipationRateSearchCriteria): Promise<ParticipationRateEntity[]> => {
        return await axiosPostData(referenceAxiosInstance, url, searchCriteria).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });

    }

    const updateEntity = async (updatedData: ParticipationRateEntity): Promise<ResponseEntity> => {
        return await axiosPutData(referenceAxiosInstance, `${url}`, updatedData);
    }

    const applyEntity = async (applyData: ParticipationRateEntity[]): Promise<ResponseEntity> => {
        const newUrl = url + '/apply';
        return await axiosPostData(referenceAxiosInstance, `${newUrl}`, applyData);
    }

    return {
        getEntities: getEntities,
        updateEntity: updateEntity,
        applyEntity: applyEntity,
    }
}